import React from 'react';
import PropTypes from 'prop-types';
import { get, sample } from 'lodash';
import moment from 'moment';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  padding: 45px 0 0;
  @media(min-width: 768px) {
    padding: 65px 0;
  }
  .Testimonial_wrapper {
    background: ${colors.white};
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .Testimonial_subtitle {
      font-weight: 300;
      font-size: 26px;
      color: ${colors.brand1};
      letter-spacing: 5.05px;
      text-transform: uppercase;
      margin: 0;
      text-align: center;
    }
    .Testimonial_title {
      margin-bottom: 50px;
      text-align: center;
      @media(min-width: 768px) {
        margin-bottom: 55px;
      }
      a {
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand1};
          transition: all .3s ease-out;
        }
      }
    }
    .Testimonial_content {
      padding: 65px 0;
      border-radius: 1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .Testimonial_overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(60,157,199,.95);
        top: 0;
        left: 0;
      }

      .Testimonial_date {
        background: ${colors.brand1};
        height: 35px;
        max-width: 140px;
        padding: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 900;
        font-size: 12px;
        color: ${colors.white};
        letter-spacing: 2.16px;
        text-transform: uppercase;
        position: absolute;
        top: -17px;
        @media(min-width: 768px) {
          background: ${colors.brand2};
          border-radius: 100px;
        }
      }

      .Testimonial_body {
        font-size: 18px;
        letter-spacing: 0.3px;
        line-height: 30px;
        text-align: center;
        padding: 0 10vw;
        position: relative;
        z-index: 1;
        color: ${colors.white};
        @media(min-width: 768px) {
          padding: 0 90px;
        }
      }
      .Testimonial_source {

        font-weight: bold;
        font-size: 19px;
        position: relative;
        z-index: 1;
        color: ${colors.brand1};
        letter-spacing: 0.31px;
        position: relative;
        margin: 0;
      }

      span {
        position: relative;
        z-index: 2;
        font-size: 16px;
        color: ${colors.brand1};
      }
    }
  }

  .Testimonial_link {
    display: none;
    @media (min-width: 992px) {
      padding: 15px 20px;
      background-color: #FFFFFF;
      color: ${colors.brand2};
      font-weight: 700;
      font-size: 13px;
      text-align: center;
      display: inline-block;
      width: auto;
    }
  }

  .Testimonial_quote {
    position: absolute;
    top: -4px;
    width: 55px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
`;

class Testimonial extends React.Component {
  getTestimonial() {
    if (!this.testimonial && this.props.page) {
      this.testimonial = sample(this.props.page.testimonials);
    }
    return this.testimonial;
  }

  render() {
    const testimonial = this.getTestimonial();
    const { page } = this.props;

    if (!testimonial) {
      return null;
    }

    return (
      <div className={styles}>
        <Link name="testimonials">
          <div className="Testimonial_wrapper">
            <div className="container Testimonial_content" style={{ backgroundImage: `url(${buildThumbnailUrl(get(page, 'page_image.contentUrl'), { width: 800, height: 800 })})` }}>
              <p className="Testimonial_body">{get(testimonial, 'description')}</p>
              <h3 className="Testimonial_source">{get(testimonial, 'name')}</h3>
              {
                get(testimonial, 'location') && get(testimonial, 'date') &&
                <span>{get(testimonial, 'location')} | {moment(get(testimonial, 'date')).format('MMM YYYY')}</span>
              }
              <img src="/images/icon-quote.svg" className="Testimonial_quote" alt="Testimonial Quote" />
              <div className="Testimonial_overlay" />
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

Testimonial.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'testimonials',
  },
)(Testimonial);



// WEBPACK FOOTER //
// ./src/components/Testimonial.js